import { $, addAction, applyFilters } from '@situation/setdesign.util';
import calendarSettings from './settings';

class CalendarController {
    constructor($container, eventList) {
        this.$el = $container;
        this.eventList = eventList;
        addAction('calendar/refresh', this.refresh, 10, this);
        addAction('calendar/noResults', this.hide, 10, this);
        addAction('calendar/gotoMonth', this.goto, 10, this);
        addAction('toggleActive', this.layout, 10, this);
        this.init();
    }

    init() {
        this.settings = applyFilters(
            'calendar/settings',
            $.extend({}, calendarSettings, {
                validRange: () => this.eventList.range(),
                events: (_start, _end, _timezone, callback) => {
                    callback(this.eventList.get());
                },
            }),
        );

        this.$el.fullCalendar(this.settings);
    }

    refresh() {
        this.$el.removeClass('calendar-container--no-results');
        const selectedMonth = this.$el.fullCalendar('getView').intervalStart;
        this.$el.fullCalendar('destroy');
        this.init();
        const range = this.eventList.range();
        const month = selectedMonth.isBetween(range.start, range.end, 'month', '[]') ? selectedMonth : range.start;
        this.goto(month);
    }

    hide() {
        this.$el.addClass('calendar-container--no-results');
    }

    goto(month) {
        this.$el.fullCalendar('gotoDate', month);
    }

    layout() {
        this.$el.fullCalendar('rerenderEvents');
    }
}

export default CalendarController;
